import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, get } from "firebase/database";

export default function useFetchQuestion(domainId, categoryId, questionId) {

    const [question, setQuestion] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        
        if (!domainId || !questionId || !categoryId) { 
            return; // no fetch if not provided
        }

        const fetchQuestion = async () => {
            setLoading(true);
            setError(null);
            try {
                const questionRef = ref(db, `Questions/CategoryQuestions/${domainId}/${categoryId}/${questionId}`);
                const snapshot = await get(questionRef);

                if (snapshot.exists()) {
                    setQuestion({ id: questionId, ...snapshot.val() });
                } else {
                    setQuestion(null);
                    setError("Question not found");
                }
            } catch (err) {
                console.error("Error fetching question:", err);
                setError("Failed to load question data");
            } finally {
                setLoading(false);
            }
        };

        fetchQuestion();
    }, [domainId, categoryId,questionId]);

    return { question, loading, error };
}
